'use client';

import React from "react";
import {Layout} from "antd";

const EmptyLayout = ({children}: React.PropsWithChildren) => {
    return (
        <Layout style={{minHeight: '100vh'}}>
            {children}
        </Layout>
    );
};

export default EmptyLayout;
